import settings from '~/common/constants/settings.json';
import { format, getWeek } from 'date-fns';
import moment, { Moment } from 'moment';
export interface HoursMinutesSeconds {
  hours: number;
  minutes: number;
  seconds: number;
}

export const secondsToHoursMinutesSeconds = (
  secondsToConvert: number | null | undefined
): HoursMinutesSeconds => {
  if (typeof secondsToConvert === 'number' && secondsToConvert >= 0) {
    let mySeconds = secondsToConvert;
    const hours = Math.floor(mySeconds / 60 / 60);
    mySeconds -= hours * 60 * 60;
    const minutes = Math.floor(mySeconds / 60);
    mySeconds -= minutes * 60;
    const seconds = mySeconds;
    return { hours, minutes, seconds };
  }
  return { hours: 0, minutes: 0, seconds: 0 };
};

export const secondsToFormatTime = (
  seconds: number | null | undefined,
  forceTwoDigits: boolean,
  returnSeconds: boolean,
  minHours?: number
) => {
  if (typeof seconds === 'number') {
    let returnString = '';
    if (seconds < 0) returnString += '-';
    seconds = Math.abs(seconds);

    const hoursMinutesSeconds = secondsToHoursMinutesSeconds(seconds);
    if (hoursMinutesSeconds.hours > 0) {
      if (minHours) {
        const lengthOfHoursMinutesSecondsHours =
          hoursMinutesSeconds.hours.toString().length;
        const amountOfZerosToAdd = minHours - lengthOfHoursMinutesSecondsHours;
        if (amountOfZerosToAdd > 0) {
          for (let i = 0; i < amountOfZerosToAdd; i++) {
            returnString += '0';
          }
        }
      } else if (hoursMinutesSeconds.hours < 10 && forceTwoDigits) {
        returnString += '0';
      }
      returnString += hoursMinutesSeconds.hours + ' h ';
    } else if (minHours) {
      for (let i = 0; i < minHours; i++) {
        returnString += '0';
      }
      returnString += ' h ';
    }
    if (hoursMinutesSeconds.minutes >= 0) {
      if (hoursMinutesSeconds.minutes < 10 && forceTwoDigits)
        returnString += '0';
      returnString += hoursMinutesSeconds.minutes + ' min';
    }
    if (returnSeconds) {
      if (hoursMinutesSeconds.seconds != 0) {
        if (hoursMinutesSeconds.seconds < 10 && forceTwoDigits)
          returnString += '0';
        returnString += ' ' + hoursMinutesSeconds.seconds + ' s';
      }
    }
    if (returnString === '') returnString = '00 h 00 min';
    return returnString;
  } else {
    return '00 h 00 min';
  }
};

export const secondsToFormatHMin = (
  seconds: number | null | undefined,
  forceTwoDigits: boolean,
  minHours?: number
) => {
  return secondsToFormatTime(seconds, forceTwoDigits, false, minHours);
};

export const secondsToFormatHMinS = (
  seconds: number | null | undefined,
  forceTwoDigits: boolean,
  minHours?: number
) => {
  return secondsToFormatTime(seconds, forceTwoDigits, true, minHours);
};

export const isoStringToDate = (isoString: string) => {
  const date = new Date(isoString);
  return date.toLocaleDateString();
};

export const momentDurationToSeconds = (duration: number | string) => {
  if (typeof duration === 'string') {
    const hours = duration.substr(0, 2);
    const minutes = duration.substr(3, 2);
    const seconds = duration.substr(6, 2);
    const durationAsSeconds: number =
      parseInt(hours, 10) * 60 * 60 +
      parseInt(minutes, 10) * 60 +
      parseInt(seconds, 10);
    return durationAsSeconds;
  } else {
    return duration;
  }
};

export const momentDurationToHMin = (duration: moment.Duration) => {
  console.log(duration);
  const durationInMilliseconds = duration.asMilliseconds();
  const durationInSeconds = Math.round(durationInMilliseconds / 1000);
  return secondsToFormatHMin(durationInSeconds, true);
};

interface NearestAndSecondNearestDate {
  nearestIssueDate: string;
  secondNearestIssueDate: string;
}

export const getNearestAndSecondsNearestIssueDate = (
  issueDates: Date[]
): NearestAndSecondNearestDate => {
  const today = new Date();
  const notChanged = 1000000;
  let minDifference = notChanged;
  let secondMinDifference = notChanged;
  let nearestIssueDate: Date, secondNearestIssueDate: Date;
  issueDates?.forEach((issueDate) => {
    const differenceInMilliSeconds = Math.abs(
      today.getTime() - issueDate.getTime()
    );
    const differenceInDays = Math.ceil(
      differenceInMilliSeconds / (1000 * 3600 * 24)
    );
    if (differenceInDays < minDifference) {
      secondMinDifference = minDifference;
      secondNearestIssueDate = nearestIssueDate;
      minDifference = differenceInDays;
      nearestIssueDate = issueDate;
    }
  });
  if (nearestIssueDate) {
    if (minDifference === notChanged)
      return { nearestIssueDate: '', secondNearestIssueDate: '' };
    const nearestIssueDateString = nearestIssueDate.toLocaleDateString();
    if (secondMinDifference === notChanged)
      return {
        nearestIssueDate: nearestIssueDateString,
        secondNearestIssueDate: nearestIssueDateString,
      };
    const secondNearestIssueDateString =
      secondNearestIssueDate.toLocaleDateString();
    return {
      nearestIssueDate: nearestIssueDateString,
      secondNearestIssueDate: secondNearestIssueDateString,
    };
  }
  return undefined;
};

export const secondsToDuration = (seconds: number) => {
  return moment.duration(seconds, 'seconds');
};

export const getNumberOfWeek = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
  const dayInMilliseconds = 86400000;
  const pastDaysOfYear =
    (today.getTime() - firstDayOfYear.getTime()) / dayInMilliseconds;
  return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
};

export const getTimeFromMilliseconds = (
  milliseconds: number,
  showMilliseconds = true
) => {
  const timeDate = new Date(milliseconds);
  let timeFromDate = getTimeFromDate(timeDate);

  if (!showMilliseconds) {
    timeFromDate = timeFromDate.substring(0, timeFromDate.length - 3);
  }

  return timeFromDate;
};

export const getTimeFromDate = (date: Date) => {
  return date.toLocaleTimeString();
};

export const getDateWithoutTimeFromMilliseconds = (
  milliseconds: number,
  showYear = true
) => {
  const dayDate = new Date(milliseconds);
  let dateWithoutTime = getDateWithoutTime(dayDate);

  if (!showYear) {
    dateWithoutTime = dateWithoutTime.substring(0, dateWithoutTime.length - 5);
  }

  return dateWithoutTime;
};

export const getDateAndTimeInHMinFromMilliseconds = (milliseconds: number) => {
  const date = getDateWithoutTimeFromMilliseconds(milliseconds);
  const dateWithoutYear = date.substring(0, date.length - 5);
  const seconds = Math.round(milliseconds / 1000);
  const timeInHMin = secondsToFormatHMin(seconds, true);
  return `${dateWithoutYear} ${timeInHMin}`;
};

export const getDateWithoutTime = (date: Date) => {
  return date.toLocaleDateString();
};

export const getDateOrKW = (date: Date, kw?: boolean) => {
  if (date && kw) {
    return `KW ${getWeek(date)}`;
  }
  return getDateWithoutTime(date);
};

export const getTodayWithoutTime = () => {
  return getDateWithoutTime(new Date());
};

export const getDateFromMillisecondsInInputNotation = (
  milliseconds: number | null | undefined
) => {
  if (!milliseconds) {
    return null;
  }
  const dayDate = new Date(milliseconds);
  return dayDate.toISOString().substr(0, 10);
};

export const getTodayWithoutTimeForFileName = () => {
  const todayAsISOString = new Date().toISOString();
  const day = todayAsISOString.substr(8, 2);
  const month = todayAsISOString.substr(5, 2);
  const year = todayAsISOString.substr(0, 4);
  return year + '-' + month + '-' + day;
};

export const getMillisecondsFromDateInput = (dateString: string) => {
  return new Date(dateString).valueOf();
};

export const getISOStringForTable = (milliseconds: number) => {
  let isoString = new Date(milliseconds).toISOString();
  isoString = isoString.replace('T', ' ');
  isoString = isoString.replace('Z', '');
  return isoString;
};

export const toApiDateFromDate = (date: Date | null | undefined) => {
  if (!date) {
    return '';
  }
  return format(date, 'yyyy-MM-dd');
};

export const toApiDate = (date: Moment) => {
  return date?.utc().format(settings.apiDateForamt);
};
